import { useState } from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { informationCircleOutline } from 'ionicons/icons';
import { HelpModal } from '../../pages/fantasy-leagues-tabs/components/HelpModal';
import { getMarkdownHelp } from '../../constants/helpContent';

export const MarkdownHelpButton = () => {
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const help = getMarkdownHelp();

  return (
    <>
      <IonButton
        fill="clear"
        size="small"
        aria-label="Ayuda de formato"
        onClick={() => setIsHelpModalOpen(true)}
      >
        <IonIcon slot="icon-only" icon={informationCircleOutline} />
      </IonButton>

      <HelpModal
        isOpen={isHelpModalOpen}
        onClose={() => setIsHelpModalOpen(false)}
        title={help.title}
        content={help.content}
      />
    </>
  );
};
